import * as React from "react";

function SvgIcons8CursorInWindow(props, ref) {
  return (
    <svg viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path d="M4 4v24h15v-2H6V12h20v7.63l2 1.866V4H4zm2 2h20v4H6V6zm1 1v2h2V7H7zm3 0v2h2V7h-2zm3 0v2h2V7h-2zm8 10.7v14.238l3.695-3.473 1.49 3.25 1.819-.834-1.479-3.223 4.885-.244-1.728-1.611L21 17.699zm2 4.6l3.592 3.352-1.928.096L23 27.312v-5.011z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8CursorInWindow);
